import { action } from "satcheljs";

export const getImportJobs = action("getImportJobs",
    (teamId: string ) => ({ teamId: teamId })
);
